import { assertAiWriteAllowed } from "@medflyt/webapp-react/src/core/ai-write-guard";

/**
 * The AngularJS half of the AI write rule.
 *
 * Most writes in this app still go through `$http` (DatabaseApi wraps it), so the rule that the AI
 * omnibar may only navigate and prefill has to be enforced here too, not just in the React API
 * client. A capability that tries to save something gets its request rejected before it is sent.
 *
 * See webapp-react/src/core/ai-write-guard.ts for the rule itself.
 */
//! @ngInject
export function aiWriteGuardConfig($httpProvider) {
  $httpProvider.interceptors.push([
    "$q",
    function ($q) {
      return {
        request: function (config) {
          try {
            assertAiWriteAllowed(config.method ?? "GET", config.url ?? "");
          } catch (error) {
            return $q.reject(error);
          }

          return config;
        },
      };
    },
  ]);
}
